import { cn } from "@/lib/utils";

/**
 * A form/section micro-label: POST TO, YOUR IDEA, SERVICE, TARGET PERSONA, CURRENT WORKSPACE.
 * IBM Plex Mono ~10-11px, letterspaced, steel dark, uppercase.
 * See .flow/DESIGN-SPEC.md § signature elements (micro-labels).
 */
export interface MicroLabelProps {
  children: React.ReactNode;
  className?: string;
  as?: "span" | "div" | "label" | "p";
  htmlFor?: string;
}

export function MicroLabel({ children, className, as = "span", htmlFor }: MicroLabelProps) {
  const Tag = as as React.ElementType;
  return (
    <Tag
      htmlFor={htmlFor}
      className={cn(
        "font-mono uppercase text-steel-dark text-[10px] leading-none",
        "tracking-[0.13em]",
        className,
      )}
    >
      {children}
    </Tag>
  );
}

export default MicroLabel;
